// src/components/store/sections/hero-banner/HeroV13CyberhudFuchsiaGlow.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV13CyberhudFuchsiaGlow(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={13}
      archKey="cyber_hud"
      archLabel="Cyberpunk HUD Matrix"
      palName="FuchsiaGlow"
      grad="from-fuchsia-500 via-pink-500 to-purple-700"
      lightBg="bg-fuchsia-50"
      textCol="text-fuchsia-700"
      borderCol="border-fuchsia-200"
      btnCls="bg-fuchsia-600 hover:bg-fuchsia-700"
      {...props}
    />
  );
}
